import CheckoutOptions from "../../Models/CheckoutOptions";
import { DibsCheckoutComplete } from "../../Models/Interfaces/DibsCheckoutComplete";
import { DibsWindow } from "../../Models/Interfaces/DibsWindow";

declare let window: DibsWindow;

export default class DibsCheckout {
	container: HTMLDivElement;
	containerId: string;
	checkoutKey: string;
	paymentId: string;
	language: string;

	constructor(paymentId: string, checkoutKey: string) {
		this.container = document.querySelector('.bill-total + div');
		this.containerId = this.container.id;
		this.language = this.container.dataset.lang.includes("da") ? "da-DK" : "en-GB";
		this.paymentId = paymentId;
		this.checkoutKey = checkoutKey;
	}

	public checkoutOrder(): Promise<string> {
		return new Promise<string>((resolve, reject) => {
			var checkoutOptions = new CheckoutOptions(this.checkoutKey, this.paymentId, this.containerId, this.language);
			var checkout = new window.Dibs.Checkout(checkoutOptions);
			checkout.on('payment-completed', function ({ paymentId }: DibsCheckoutComplete) {
				resolve(paymentId);
			});
		})
	}
}
